import { TranslationObject } from '@ngx-translate/core';

const kk: TranslationObject = {
  kk: 'Қазақ',
  app: {
    test: 'Бұл сынақ жапсырмасы',
    title: 'SWD - Жұмыс Тәртібі',
    welcomeMessage: 'SWD веб-қосымшасына қош келдіңіз',
    forms: {
      ok: 'Ok',
      cancel: 'Болдырмау',
      create: 'Жасау',
      continue: 'Жалғастыру',
      labels: {
        businessUnit: 'Бизнес бөлімшесі',
        placeholderBusinessUnit: 'Бизнес-бірлікті таңдаңыз',
        user: 'Пайдаланушы',
        name: 'аты-жөні',
        description: 'Сипаттамасы',
        placeHolderDescription: 'Сипаттаманы енгізіңіз',
        placeHolderReviewType: 'Шолу түрін таңдаңыз',
        mandatory: 'Міндетті',
      },
      unsavedChangesWarning:
        'Сақталмаған өзгерістер анықталды. Егер сіз осы бетті қалдырсаңыз, жасаған өзгерістеріңіз жоғалады.<br>Жалғастырғыңыз келе ме?',
    },
    warnings: {
      removeOwnAccess: 'Қол жеткізуіңізді алып тастадыңыз. Қате болдырмау үшін веб-бетті жаңартыңыз.',

      removeOwnAdminRights: 'Әкімші құқықтарыңызды алып тастадыңыз. Қате болдырмау үшін веб-бетті жаңартыңыз.',
    },
  },
  navigation: {
    startWorkDone: 'Бақылаулар',
    category: 'Санаттар',
    businessUnits: 'Бизнес бөлімшелер',
    administration: 'Әкімшілік',
    sysAdmins: 'Жүйе Әкімшілері',
    users: 'Пайдаланушылар',
    areas: 'Аймақтар',
    errorReductionTools: 'Қателерді азайту құралдары',
    nonBadgedPersons: 'Рұқсатнамасыз бақыланатын адамдар',
  },
  startWorkDoneList: {
    title: 'Бақылаулар',
    noStartWorkDone:
      'Жазбаларды көрсету үшін Бизнес бөлімшесін, Аймақты, Қосымша аймақты, Санатты және Бақыланатын адамды таңдаңыз',
    emptyList: 'Таңдалған сүзгілер бойынша Жұмыс Тәртібі жазбалары табылмады',
    id: 'ID',

    responseTitle: 'Тақырып',

    question: 'Бақылау',
    answer: 'Жауап',
    score: 'Ұпай',
    comment: 'Түсініктеме',
    errorReductionTool: 'Қателерді азайту құралы',
    updatedBy: 'Жаңартқан ',
    updatedDate: 'Жаңарту күні',
    createNewStartWorkDone: 'жаңа жұмыс бастау жасау',
    reviewType: 'Шолу түрі',
    area: 'Аймақ',
    observationDate: 'Бақылау күні',
    subArea: 'Қосымша аймақ',
    category: 'Санат',
    placeholderArea: 'Аймақты таңдаңыз',
    placeholderSubArea: 'Қосымша аймақты таңдаңыз',
    placeholderCategory: 'Санатты таңдаңыз',
    addQuestion: 'Бақылау қосу',
    description: 'Сипаттама',
    subSection: 'Қосымша бөлім',
    clearAnswer: 'Жауапты тазалау',
    deleteQuestion: 'Бақылауды жою',
    deleteQuestionTitle: 'Бақылауды жою',
    confirmDeleteQuestion:
      '<span>Бұл бақылауды жоюға сенімдісіз бе?</span><br><br><span><b>Бақылау:</b> {{ description }}</span>',
    editQuestion: 'Бақылауды өңдеу',
    editQuestionHeader: 'Бақылауды өңдеу',
    userSearch: 'Бақыланатын адам',
    userSearchPlaceholder: 'Аты немесе электрондық пошта бойынша іздеу...',
    supervisor: 'Жетекші',
    noSupervisor: 'Жетекші табылмады',
    nonBadgedPersonObserved: 'Рұқсатнамасыз бақыланатын адам',
    placeholderNonBadgedPersonObserved: 'Рұқсатнамасыз адамды таңдаңыз',
    personSelectionConflict:
      'Келесі өрістердің тек біреуін толтыруға болады: Бақыланатын адам немесе Рұқсатнамасыз бақыланатын адам.',
    generateReport: 'Есепті құру',
    completeReview: 'Шолуды аяқтау және Есепті Жіберу',
    generateReportInfoMessage: 'Есебіңіз жасалуда және автоматты түрде жүктеледі. Бұл бірнеше секунд алуы мүмкін.',
    generateSuccessMessage: 'Есеп сәтті жасалды',
    reviewSuccessMessage: 'SWD бақылау есебі сәтті жіберілді',
    sendEmail: 'Email Жіберу',
    emailSuccessMessage: 'Email сәтті жіберілді',
    emailErrorMessage: 'Email жіберу қателігі',
    tableColumns: {
      businessUnit: 'Бизнес бөлімшесі',
      category: 'Санат',
      subArea: 'Қосымша аймақ',
      area: 'Аймақ',
      user: 'Бақыланатын адам',
      nonBadgedPerson: 'Рұқсатнамасыз бақыланатын адам',
      supervisor: 'Қадағалаушы',
      observationDate: 'Бақылау күні',
      totalScore: 'Жалпы ұпай',
      createdBy: 'Бақылаушы',
    },
    viewEdit: 'Қарау / Өңдеу',
  },
  startWorkDoneDetail: {
    title: 'Бақылау',
    details: 'Жалпы Ақпарат',
    notFound: 'Жұмыс Тәртібі жазбасы табылмады',
    accessDenied: 'Сізде бұл бақылауға қол жеткізу мүмкіндігі жоқ.',
    saveSuccess: 'Жазба сәтті жаңартылды',
    editInfo: 'Ақпаратты өңдеу',
    saveInfo: 'Ақпаратты сақтау',
    errorReductionTools: 'Қателерді азайту құралдары',
    noControls: 'Басқару элементтері табылмады. Алдымен осы санатқа басқару элементтерін қосыңыз.',
    totalScore: 'Жалпы балл',
    deleteObservation: 'Бақылауды жою',
    deleteConfirmTitle: 'Бақылауды жою',
    deleteConfirmMessage: 'Бұл бақылауды жойғыңыз келетіні сенімдісіз бе? Бұл әрекетті кері қайтару мүмкін емес.',
    deleteSuccess: 'Бақылау сәтті жойылды',
    noObservationDate: 'Бақылау күні таңдалмаған. Шолуды аяқтамас бұрын күнді таңдаңыз.',
  },
  categoryList: {
    title: 'Санаттар',
  },
  admin: {
    sysAdminList: {
      title: 'Жүйе Әкімшілері',
      addSysAdmin: 'жүйе әкімшісін қосу',
      fullName: 'Толық Аты-жөні',
      email: 'Электрондық пошта',
      dialogs: {
        removeAccessHeader: 'Растау',
        removeAccessMessage: '{{firstName}} {{lastName}} үшін жүйе әкімші қолдану құқығын алып тастағыңыз келеді ме?',
      },
    },
    businessUnitLists: {
      title: 'Бизнес бөлімшелер',
      addBusinessUnit: 'бизнес бөлімін қосу',
      tableTitle: 'Бизнес бөлімшесі',
      noBusinessUnits: 'Бизнес бөлімшелер табылмады.',
      dialogs: {
        createHeader: 'Бизнес бөлімшесін жасау',
        namePlaceholder: 'Атауды енгізіңіз',
      },
    },
    businessUnitEdit: {
      title: 'Бизнес бөлімшесін өңдеу',
    },
    errorReductionTools: {
      title: 'Қателерді азайту құралдары',
      addErt: 'қателерді азайту құралын қосу',
      tableTitle: 'қателерді азайту құралы',
      noErts: 'Қателерді азайту құралдары табылмады.',
      dialogs: {
        createHeader: 'Қателерді азайту құралын жасау',
        editHeader: 'Қателерді азайту құралын өңдеу',
        namePlaceholder: 'Атауды енгізіңіз',
        deleteTitle: 'Қателерді азайту құралын жою',
        deleteMessage: '<strong>{{name}}</strong> қателерді азайту құралын жойғыңыз келетіні сенімдісіз бе?',
        deleteSuccess: 'Қателерді азайту құралы сәтті жойылды.',
        deleteConflict:
          'Бұл қателерді азайту құралын жою мүмкін емес, себебі ол бір немесе бірнеше бақылауға тіркелген.',
      },
    },
    nonBadgedPersons: {
      title: 'Рұқсатнамасыз бақыланатын адамдар',
      addPerson: 'рұқсатнамасыз бақыланатын адамды қосу',
      importPeople: 'рұқсатнамасыз пайдаланушыларды импорттау',
      noPeople: 'Рұқсатнамасыз адамдар табылмады.',
      columns: {
        name: 'рұқсатнамасыз бақыланатын адам',
        supervisorEmail: 'жетекшінің электрондық поштасы',
        supervisorName: 'жетекшінің аты',
      },
      dialogs: {
        createHeader: 'Рұқсатнамасыз бақыланатын адамды қосу',
        editHeader: 'Рұқсатнамасыз бақыланатын адамды өңдеу',
        nameLabel: 'Рұқсатнамасыз адам',
        nameRequired: 'Аты міндетті',
        supervisorLabel: 'Жетекші',
        supervisorPlaceholder: 'Аты немесе электрондық пошта бойынша іздеу...',
        supervisorRequired: 'Электрондық пошта міндетті',
        deleteTitle: 'Рұқсатнамасыз адамды жою',
        deleteMessage: '<strong>{{name}}</strong> рұқсатнамасыз адамын жойғыңыз келетініне сенімдісіз бе?',
        deleteSuccess: 'Рұқсатнамасыз адам сәтті жойылды.',
        deleteConflict: 'Бұл рұқсатнамасыз адамды жою мүмкін емес, себебі ол бір немесе бірнеше бақылауға қатысқан.',
        importHeader: 'Рұқсатнамасыз бақыланатын адамдарды импорттау',
        attachDocument: 'Құжат тіркеу',
        uploadedOn: 'Жүктелді: {{date}}',
        removeFile: 'Файлды алып тастау',
        invalidFile: 'Көлемі 5 МБ-тан аспайтын бір Excel (.xlsx) файлын таңдаңыз.',
        importFailed: 'Ештеңе импортталмады. Осы қателерді түзетіп, қайталап көріңіз:',
        importSuccess: 'Импорт аяқталды. Импортталды: {{imported}}. Өткізілген қайталанулар: {{skipped}}.',
      },
    },
    areas: {
      title: 'Аймақтар',
      areasTitle: 'Аймақтар',
      subAreasTitle: 'Қосымша аймақтар',
      addArea: 'Аймақ қосу',
      addSubArea: 'Қосымша аймақ қосу',
      areaName: 'Атауы',
      subAreaName: 'Қосымша аймақтар',
      category: 'Санат',
      noAreas: 'Қолжетімді аймақтар жоқ.',
      noSubAreas: 'Қолжетімді қосымша аймақтар жоқ.',
      selectAreaMessage: 'Қосымша аймақтарын басқару үшін аймақты таңдаңыз.',
      dialogs: {
        createAreaHeader: 'Аймақ жасау',
        editAreaHeader: 'Аймақты өңдеу',
        createSubAreaHeader: 'Қосымша аймақ жасау',
        editSubAreaHeader: 'Қосымша аймақты өңдеу',
        namePlaceholder: 'Атауды енгізіңіз',
        category: 'Санат',
        categoryPlaceholder: 'Санатты таңдаңыз (міндетті емес)',
        deleteAreaTitle: 'Аймақты жою',
        deleteAreaMessage: '<strong>{{name}}</strong> аймағын жойғыңыз келетініне сенімдісіз бе?',
        deleteAreaLinkedRecords: 'Бұл аймақты жою мүмкін емес, себебі оған байланысты Жұмыс Тәртібі жазбалары бар.',
        deleteSubAreaTitle: 'Қосымша аймақты жою',
        deleteSubAreaMessage: '<strong>{{name}}</strong> қосымша аймағын жойғыңыз келетініне сенімдісіз бе?',
        deleteSubAreaLinkedRecords:
          'Бұл қосымша аймақты жою мүмкін емес, себебі оған байланысты Жұмыс Тәртібі жазбалары бар.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Тіркелмеген',
      forms: {
        submit: 'Кіру құқығын сұрату',
      },
      dialogTitle: 'Кіру құқығын сұрату',
      dialogSubtitle: 'Сіз <strong>{{name}}</strong> үшін рұқсат сұрағалы тұрсыз, жалғастырғыңыз келеді ме?',
      reloadWarning:
        'Егер сіз осы бетке кірсеңіз, бірақ сізде қол жеткізу болса, қайта жүктеу үшін келесі сілтемені басыңыз, әйтпесе қолдау қызметіне хабарласыңыз.',
      reload: 'Қайта жүктеу',
    },
    pendingAccess: {
      title: 'Сәлем, Кіру құқығына берген сұратынымыңыз орындалуда',
      reloadWarning:
        'Егер сіз осы бетке кірсеңіз, бірақ сізде қол жеткізу болса, қайта жүктеу үшін келесі сілтемені басыңыз, әйтпесе қолдау қызметіне хабарласыңыз.',
      reload: 'Қайта жүктеу',
    },
  },
  header: {
    logoAlt: 'CVX логотипі',
    userAvatarAlt: 'Пайдаланушы аватары',
    unknownUser: 'Белгісіз',
  },
  footer: {
    text: 'Chevron Corporation. Барлық құқықтар қорғалған.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Санаттар',
    create: 'Жасау',
    name: 'Аты',
    description: 'Сипаттама',
    actions: 'Әрекеттер',
    edit: 'Өңдеу',
    manage: 'Басқару',
    delete: 'Жою',
    confirmDelete:
      '<span>Бұл санатты жойғыңыз келе ме?</span><br><br><span>Аты-жөні: {{ name }}<br>Сипаттамасы: {{ description }}</span>',
    noCategories: 'Санаттар жоқ.',
    titleCreate: 'Санат жасау',
    createNew: 'Жаңасын жасау',
    selectPlaceholder: 'Біреуін таңдаңыз...',
    titleEdit: 'Санатты өңдеу',
    titleDelete: 'Санатты жою',
    deletedSuccessfully: 'Санат сәтті жойылды',
    importCategory: 'Санат импорттау',
    importCategoryTitle: 'Санатты импорттау',
    selectCategoryType: 'Санат түрін таңдау',
    confirm: 'Растау',
    importSuccessMessage: 'Санат сәтті импортталды',
    manageControls: 'Бақылауларды басқару',
    noControls: 'Бақылаулар қолжетімсіз.',
    selectBusinessUnit: 'Бақылауларды көрсету үшін бизнес-бөлімшесіні таңдаңыз',
    importCategoriesTitle: 'Санаттарды импорттау',
    import: 'Импорттау',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Сақтау',
    businessUnit: 'Бизнес бөлімшесі',
    forbidActionErrorMessage: 'Пайдаланушы бұл әрекетті орындауға рұқсат етілмеген',
    name: 'Аты',
    code: 'Код',
    cancel: 'Болдырмау',
    genericErrorMessage: 'Күтпеген қате орын алды. Кейінірек қайта көріңізші.',
    savedSuccessfully: 'Сәтті сақталды',
    delete: 'жою',
    deletedSuccessfully: 'Сәтті жойылды',
    edit: 'Өңдеу',
    leaveWithOutSaving: 'Сақтамай шығу',
    language: 'Тіл',
    view: 'Қарау',
    back: 'Артқа',
    createdBy: 'Жасаған',
    updatedBy: 'Жаңартқан',
    updatedDate: 'Жаңарту күні',
    errors: {
      failedToSubmit: 'Жауапты жіберу сәтсіз аяқталды. Қайталап көріңіз.',
    },
  },
  serverError: {
    title: 'Сервер қолжетімсіз',
    message: 'Серверге қосылу мүмкін емес. Желі байланысын тексеріңіз немесе кейінірек қайталап көріңіз.',
    returnHome: 'Басты бетке оралу',
  },
  pageNotFound: {
    title: 'Бет табылмады',
    message: 'Сіз іздеген бет жоқ.',
    returnHome: 'Басты бетке оралу',
  },
  unauthorized: {
    title: 'Рұқсат етілмеген кіру',
    message: 'Сізде бұл бетке кіруге рұқсат жоқ.',
    returnHome: 'Басты бетке оралу',
  },
  categoryManage: {
    title: 'Мазмұнын басқару [{{ description }}]',
    questionsTitle: 'Бақылаулар',
    addQuestionAction: 'бақылау қосу',
    questionName: 'Бақылау',
    questionNamePlaceholder: 'Бақылау мәтінін енгізіңіз',
    errorReductionTools: 'Қателерді азайту құралдары',
    ertPlaceholder: 'Қателерді азайту құралдарын таңдаңыз',
    noQuestions: 'Бақылаулар табылмады. Бастау үшін бақылау қосыңыз.',
    sectionsTitle: 'Бөлімдер',
    subSectionsTitle: 'Ішкі бөлімдер',
    addSectionAction: 'бөлім қосу',
    mandatoryLabel: 'Міндетті',
    createNewSubsectionAction: 'бақылаулар тобын қосу',
    emptySubSectionsMessage: '<p>Бұл бөлім үшін қолжетімді мазмұн жоқ.</p><p>Бастау үшін қосымша бөлім қосыңыз.</p>',
    itemDescriptionTableHeader: 'Сипаттамасы',
    createNewItemAction: 'Бақылау қосу',
    createSectionHeader: 'Жаңа бөлім жасау',
    editSectionHeader: 'Бөлімді өңдеу',
    confirmDeleteSection: 'Сіз <strong>{{description}}</strong> бөлімін жойғыңыз келе ме?',
    createSubSectionHeader: 'Бақылаулар тобын қосу',
    editSubSectionHeader: 'Бөлімшені өңдеу',
    createQuestionTitle: 'Бақылау жасау',
    ShouldAddCommentToQuestion: 'Пайдаланушы N/A деп жауап берілген кез келген бақылауға түсініктеме қосуы керек',
    deleteQuestionTitle: 'Бақылауды жою',
    confirmDeleteQuestion:
      '<span>Бұл бақылауды жойғыңыз келе ме?</span><br><br><span><b>Сипаттама:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Сіз <strong>{{description}}</strong> бөлімшесін жойғыңыз келе ме?',
    deleteSectionHeader: 'Бөлімді жою',
    deleteSubSectionHeader: 'Бөлімшені жою',
    editQuestionTitle: 'Бақылауды өңдеу',
    defaultSubSectionName: 'Бақылаулар',
  },
  paginator: {
    previous: 'Алдыңғы',
    next: 'Келесі',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} ішінен {{totalRecords}}',
  },
  usersList: {
    title: 'Пайдаланушылар',
    forms: {
      displayInactiveUsers: 'белсенді емес пайдаланушыларды көрсету',
    },
    actions: {
      addNewUser: 'Жаңа пайдаланушыны қосу',
      grantAccess: 'қол жеткізуді беру',
    },
    table: {
      fullName: 'Толық Аты-жөні',
      email: 'Электрондық пошта',
      admin: 'әкімші',
    },
    noUsers: 'Пайдаланушылар қолжетімді емес',
    dialogs: {
      removeAccessHeader: 'Растау',
      removeAccessMessage: '[{{fullName}}] үшін қол жеткізуді алып тастағыңыз келетініне сенімдісіз бе?',
    },
  },
  actionItems: {
    id: '№',
    title: 'Әрекет тармақтары',
    addActionItem: 'іс-әрекет тармағын қосу',
    actionTitle: 'Тақырып',
    assignee: 'Тағайындалушы',
    date: 'Күні',
    comment: 'Түсініктеме',
    priority: 'Басымдылық',
    dialogs: {
      configureActionItem: 'Әрекет тармағын конфигурациялау',
      configureComment: 'Түсініктеме',
      deleteActionItemHeader: 'Әрекет тармағын жою',
      deleteActionItemMessage: 'Осы әрекетті орындағыңыз келетініне сенімдісіз бе?',
    },
  },
  comments: {
    title: 'Қысқаша пікірлер',
    addComment: 'қысқаша пікір қосу',
    noComments: 'Түсініктемелер жоқ',
    dialogs: {
      configureComment: 'Түсініктеме',

      deleteCommentHeader: 'Комментарийді жою',
      deleteCommentMessage: 'Осы әрекетті орындағыңыз келетініне сенімдісіз бе?',
    },
    comment: 'Түсініктеме',
    instructions: {
      title: 'Пікірлер төмендегілерді қамтуы керек:',
      observed: 'Не байқалды',
      coaching: 'Қандай коучинг берілді',
      action: 'Мәселелерді шешу үшін қандай іс-қимас қабылданды',
      feedback: 'Күтімдерін асасы үшін қандай оң кері байланыс берілді',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Бақылау пікірі',
      },
      placeholders: {
        enterComment: 'Осы жауапқа арналған коучинг пікіріңіз немесе контексті өңгіңіз...',
      },
      messages: {
        responseSubmitted: 'Жауап сәтті жібірілді',
        commentRequired: 'Бұл жауап түрі үшін пікір қажет',
      },
      responseAnswers: {
        noAttempt: 'Әрекет жоқ',
        needsImprovement: 'Жақсартуды қажет',
        meetsExpectations: 'Күтінісіне сәйкес',
        exceedsExpectations: 'Күтінісінен асады',
        notApplicable: 'Қолданылмайды',
      },
    },
  },
};
export default kk;
